export default __webpack_public_path__ + "static/media/Padding.35424147.svg";